/* eslint-disable no-restricted-imports */
import {
  Box,
  type BoxProps,
  Badge as MBadge,
  type BadgeProps as MBadgeProps,
} from '@mantine/core'
import clsx from 'clsx'

import classes from './styles.module.css'

export type BadgeProps = BoxProps &
  MBadgeProps & {
    withDot?: boolean
  }

export function Badge({
  withDot,
  children,
  className,
  variant,
  size = 'sm',
  rightSection,
  leftSection,
  ...props
}: BadgeProps) {
  let c = 'gray.7'
  let color = 'gray.4'

  if (!props.color || props.color === 'gray') {
    c = 'gray.7'
    color = 'gray.5'
  } else {
    c = `${props.color}.7`
    color = `${props.color}.3`
  }

  return (
    <Box {...props} className={clsx(classes.wrapper, className, classes[size])}>
      <MBadge
        c={c}
        size={size}
        color={color}
        variant={variant}
        leftSection={leftSection}
        rightSection={rightSection}
      >
        {withDot && (
          <Box
            style={{
              height: '5px',
              width: '5px',
              borderRadius: '50%',
            }}
            className={classes.dot}
            bg={props.color}
          />
        )}
        {children}
      </MBadge>
    </Box>
  )
}
